import { useMemo } from 'react';
import { pickGoodLuckCelebrationVideo } from './goodLuckVideos';

export type GoodLuckCelebrationMedia =
  | { status: 'loading' }
  | { status: 'video'; videoSrc: string; phrase: string; translation: string }
  | { status: 'audio'; audioSrc: string; phrase: string; translation: string }
  | { status: 'unavailable' };

/**
 * Picks a hard-coded "good luck" video for the learner's target language.
 * Videos are keyed by target locale so a German→French pair still gets a
 * French clip, even though that dictionary has no English "good luck" entry.
 */
export const useGoodLuckCelebrationMedia = (
  targetLanguageLocale?: string | null,
): GoodLuckCelebrationMedia => {
  return useMemo(() => {
    const video = pickGoodLuckCelebrationVideo(targetLanguageLocale);
    if (!video) {
      return { status: 'unavailable' };
    }

    return {
      status: 'video',
      videoSrc: video.src,
      phrase: video.phrase,
      translation: video.translation,
    };
  }, [targetLanguageLocale]);
};
